
function set_single_edits(){
    $('body').on('click', '.single-edit span', single_edit_click);
}
window.set_single_edits=set_single_edits;

function single_edit_click(e){
    let se=$(this).parent();
    let edit_data=se.data('edit_data');

    se.find('form').remove();

    console.log(edit_data);

    let form = $('<form>').attr({
        'method':'POST',
        'action': edit_data.link,
        'class': 'd-block'
    });
    if(edit_data.type=='checkbox'){
        form.append(
            $('<input>').attr({
                type: 'hidden',
                name: edit_data.name,
                value: 0,
                

            })     
        );
        form.append(
            $('<input>').attr({
                type: 'checkbox',
                name: edit_data.name,
                value: 1,
                class: 'form-control',
            }).on('click',function(){ $(this).trigger('blur');})     
        );

        if($(this).data('value')==1){
            form.find('input[type="checkbox"]').prop('checked',true);
        }

    }else if(edit_data.type=='datepicker'){



        // <strong>Valid till:</strong>
        // <input placeholder="Valid till" class="form-control form-control-sm single-date hasDatepicker" name="discount_early_booking_till_display" type="text" value="15.08.2022" id="dp1670344106096">
        // <input class="single-date-alt" name="discount_early_booking_till" type="hidden" value="2022-08-15">
        let wrapper=form.append($('<div>').attr({ class: 'single-date-block'}));
        wrapper.append(
            $('<input>').attr({
                type: 'text',
                name: edit_data.name,
                value: $(this).text(),
                class: 'form-control form-control-sm single-date'

            })     
        ).append(
            $('<input>').attr({
                type: 'hidden',
                name: edit_data.name,
                value: $(this).data('value'),
                class: 'single-date-alt',
            })     
        );

        
    }else if(edit_data.type=='textarea'){
        form.append(
            $('<textarea>').attr({
                name: edit_data.name,
                class: 'form-control se-wysiwyg',
                //class: 'form-control form-control-sm',

            }).val($(this).html())
        
        );


    }else{
        form.append(
            $('<input>').attr({
                type: 'text',
                name: edit_data.name,
                value: $(this).text(),
                class: 'form-control',
                //class: 'form-control form-control-sm',

            }).on('focus',function(){ $(this).trigger('select'); })
        
        );
    }

    if(edit_data.type=='currency'){
        form.find('input').addClass('currency');
        // form.css('width',(se.find('span').width()-0)+'px');
        // form.find('input').css('width',(se.find('span').width()-48)+'px');
        let an = set_currency_input(form.find('input')[0]);

        let val=$(this).text();
        val=val.replace('.','').replace(',','.').replace('€','').trim();
        // alert($(this).text());
        an.set(val); //FIX
        // an.setUnformatted(val); //FIX
    }else if(edit_data.type=='currency-decimal'){
        form.find('input').addClass('currency-decimal');
        // form.css('width',(se.find('span').width()-0)+'px');
        // form.find('input').css('width',(se.find('span').width()-48)+'px');
        let an = set_currency_decimal_input(form.find('input')[0]);

        let val=$(this).text();
        val=val.replace('.','').replace(',','.').replace('€','').trim();
        // alert($(this).text());
        an.set(val); //FIX
        // an.setUnformatted(val); //FIX
    }else if(edit_data.type=='integer'){
        form.find('input').addClass('integer');
        // form.css('width',(se.find('span').width()-0)+'px');
        // form.find('input').css('width',(se.find('span').width()-48)+'px');
        let an = set_integer_input(form.find('input')[0]);

        let val=$(this).text();
        val=val.replace('.','').replace(',','.').trim();
        // alert($(this).text());
        an.set(val); //FIX
        // an.setUnformatted(val); //FIX

    }else if(edit_data.type=='decimal'){
        form.find('input').addClass('decimal');
        // form.css('width',(se.find('span').width()-0)+'px');
        // form.find('input').css('width',(se.find('span').width()-48)+'px');
        let an = set_decimal_input(form.find('input')[0]);

        let val=$(this).text();
        val=val.replace('.','').replace(',','.').trim();
        // alert($(this).text());
        an.set(val); //FIX
        // an.setUnformatted(val); //FIX

    }else if(edit_data.type=='percentage'){
        form.find('input').addClass('percentage');
        // form.css('width',(se.find('span').width()-0)+'px');
        // form.find('input').css('width',(se.find('span').width()-48)+'px');
        let an = set_percentage_input(form.find('input')[0]);

        let val=$(this).text();
        val=val.replace('.','').replace(',','.').replace('%','').trim();;
        // alert($(this).text());
        an.set(val); //FIX
        // an.setUnformatted(val); //FIX
    }
    // }

    if(edit_data.method!='POST'){
        form.append(
            $('<input>').attr({
                type: 'hidden',
                name: '_method',
                value: edit_data.method
            })
        );
    }

    form.append(
        $('<input>').attr({
            type: 'hidden',
            name: '_single_edit',
            value: edit_data.name
        })
    );
    // form.append(
    //     $('<input>').attr({
    //         type: 'hidden',
    //         name: '_single_edit',
    //         value: '1'
    //     })
    // );

    if(edit_data.extra_data){
        for (const [key, value] of Object.entries(edit_data.extra_data)) {
            // console.log(`${key}: ${value}`);
            form.append(
                $('<input>').attr({
                    type: 'hidden',
                    name: key,
                    value: value
                })
            );
        }
    }

    console.log('Single edit form',form);


    form.appendTo(se);


    if(edit_data.type=='datepicker'){

        set_datepicker(form);

    }else if(edit_data.type=='textarea'){

        tinymce.init({
            selector: 'textarea.se-wysiwyg', 
            plugins: 'code table lists',
            toolbar: 'undo redo | formatselect| bold italic | alignleft aligncenter alignright | indent outdent | bullist numlist | code | table | pastetext',
            force_br_newlines : true,
            force_p_newlines : false,
            forced_root_block : '', // Needed for 3.x
    
            //https://www.tiny.cloud/docs-4x/configure/editor-appearance/#menubar
            statusbar: false,
            menubar: false,

            paste_as_text: true, // Makes the pastetext active when the editor loads

            content_style: `
                body {
                    font-family:Trebuchet MS,Tahoma,Verdana,Arial,sans-serif;
                    background: #fff;
                    font-size: 12px;
                    margin:6px;
                }
            
            `,
    
            setup: function(editor) {
                // editor.on('init', function(e) {
                //   console.log('The Editor has initialized.');
                // });
                // editor.on('change', function(e) {
                //     console.log('The Editor has changed.');
                // });
                // editor.on('keyup', function(e) {
                //     console.log('keyup: ' + e.key);
                //     if(e.key=='Escape'){
                //         $(this).closest('.single-edit').find('span').show();
                //         $(this).closest('form').remove();
                //     }
                // });
                editor.on('blur', function(e) {
                    console.log('The Editor has lost focus.', editor.getBody().innerHTML);
                    let ta=editor.getElement();
                    console.log(ta);
                    $(ta).val(editor.getBody().innerHTML);
                    $(ta).closest('form').trigger('submit');
                });
              }
    
            //https://www.tiny.cloud/docs-3x/reference/Configuration3x/Configuration3x@onchange_callback/
            // onchange_callback: function (inst){
            //     element.trigger('change');
            // }
    
            
        });
    }





    $(this).hide();

    form.find('input').trigger('focus');
    if(edit_data.type=='datepicker'){
        form.find('input.form-control').on('change',function(e){
            
            // $(this).closest('form')[0].submit();
            $(this).closest('form').trigger('submit');
        
            // var event = jQuery.Event("keyup");
            // event.key = 'Enter';
            // $(this).trigger(event);
            

        });
    }else{

        
        form.find('input.form-control').on('blur',function(e){
            
            // $(this).closest('form')[0].submit();
            $(this).closest('form').trigger('submit');
        
            // var event = jQuery.Event("keyup");
            // event.key = 'Enter';
            // $(this).trigger(event);
            

        });
        form.find('input.form-control').on('keyup',function(e){
            // console.log(e.key);
            if (e.key == 'Escape'){
                //cancel
                e.preventDefault();
                $(this).closest('.single-edit').find('span').show();
                $(this).closest('form').remove();

            }else if (e.key == 'Enter'){
                e.preventDefault();
                $(this).trigger('blur');
                // $(this).closest('form').trigger('submit');

                // let form = $(this).closest('form')[0];
        
                // form.trigger('submit');
            }
        });

    }
    
    form.on('submit',single_edit_submit);
    
    // $('<input>').attr({
    //     type: 'text',
        
    //     name: 'bar'
    // }).appendTo('form');
}

// function single_edit_submit(e){

//     if (e.type === 'blur' || e.key == 'Enter'){
//         e.preventDefault();
        
//         let form = $(this).closest('form')[0];

//         console.log(form);
        
//         submit_form({form:form, callback:single_edit_submit_response});
//     }
// }


function single_edit_submit(e){
    if($('.blockUI').length){
        return false;   //prevent multiple submit
    }
    // 
    let form = $(this)[0];

    // console.log(form);

    $(this).trigger('click');

    //check if value is updated

    // let se=$(this).closest('.single-edit');
    // let edit_data=se.data('edit_data');
    // console.log('SE', edit_data);

    if($(this).find('.form-control').attr('type')=='checkbox'){
        //alert('checkbox');
        console.log('checkbox');
    }else if($(this).find('.form-control').hasClass('sw-wysiwyg')){
        console.log('wysiwyg');
    }else{
        let new_val=$(this).find('.form-control').val().trim();
        let old_val=$(this).closest('.single-edit').find('span').text().trim();
        console.log(new_val,'=',old_val,(new_val==old_val));
        if(new_val==old_val){
            console.log('value not changed...');
            $(this).closest('.single-edit').find('span').show();
            $(this).remove();
            return false;
        }
    }

    

    
    submit_form({form:form, callback:single_edit_submit_response});
    return false;
}


function single_edit_submit_response(response){
    

    console.log('single_edit_submit_response',response);

    if(response.status=='success'){

        let name=$(response.request.form).find('.form-control').attr('name');
        let type=$(response.request.form).find('.form-control').attr('type');
        let currency=false;
        if($(response.request.form).find('.form-control').hasClass('currency')
        || $(response.request.form).find('.form-control').hasClass('currency-decimal')){
            currency=true;
        }
        if($(response.request.form).find('.form-control').hasClass('se-wysiwyg')){
            type='textarea';
        }else if($(response.request.form).find('.form-control').hasClass('single-date')){
            type='datepicker';
        }
        // alert(name);
        // alert(type);
        let val='';
        if(response.response.data[name+'_display']){
            val=response.response.data[name+'_display'];
        }else{
            val=response.response.display_data[name];
        }

        if(response.response.handling_data && response.response.handling_data.single_edit_data){
           $(response.request.form).closest('.single-edit').data('edit_data',response.response.handling_data.single_edit_data);
        }

        let span=$(response.request.form).closest('.single-edit').find('span');

        if(currency){
            span.data('value',response.response.data[name]+' €');
        }else{
            span.data('value',response.response.data[name]);
        }
        
        // span.data('value',val);

        // console.log('SE VAL',val,response.response.data[name],name);

        if(type=='checkbox'){
            // alert(val);
            if(val==1){
                span.html('<i class="fas fa-check"></i>');
            }else{
                span.html('<i class="fas fa-times"></i>');
            }
        }else if(type=='textarea'){
            span.html(val);
        }else if(currency){
            span.text(val+' €');
        }else{
            span.text(val);
        }
        span.show();
        $(response.request.form).remove();

        // alert(val);

    }else if(response.status=='error'){

        console.log(response);

        if(typeof response == 'undefined'){
            bootbox.alert('Invalid server response');
        }else{
            bootbox.alert(response.response.message);
        }

        

    }
    
    // if(response.status=='error'){
    //     show_form_errors(response.request.form, response.response.errors);
    // }else{
    //      hide_ajax_modal();
    //      if(response.response.handling=='reload'){
    //          window.location.reload();
    //      }else if(response.response.handling=='update'){
    //          //update fields values

    //         update_table_values(response);
    //      }
    // }
}